import { LoaderCircleIcon } from "lucide-react";
import { useEffect } from "react";

import legitimateLogo from "@/assets/logos/HoverSymbol.svg";
import legitimateWordmark from "@/assets/logos/Wordmark.svg";
import { LOGIN_URL } from "@/data/auth";

export const Splash = () => {
  useEffect(() => {
    window.location.assign(LOGIN_URL);
  }, []);

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <img src={legitimateLogo} alt="Legitimate Logo" className="w-12 h-12" />
      <h3 className="scroll-m-20 text-2xl tracking-tight mt-6 font-medium">
        Tag Management Dashboard
      </h3>
      <div className="flex flex-col items-center text-muted-foreground gap-2 text-center my-8">
        <LoaderCircleIcon className="size-6 animate-spin" />
        <p>Signing in...</p>
      </div>
      <img src={legitimateWordmark} alt="Legitimate wordmark" className="h-4" />
    </div>
  );
};
